import { COMPLIANCE_TYPES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/compliance_types_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'complianceTypesIndex',
	'complianceTypesDropdown',
	'complianceAdvancedFilters',
	// Supplier Documents page: resolve complianceTypeId -> type name.
	'supplierComplianceDocumentsTypes',
	// Backs the supplier Documents tab "Compliance type" async-select filter. Kept
	// separate from supplierComplianceDocumentsTypes so an in-filter search can't
	// narrow the collection the Documents page relies on for name resolution.
	'supplierComplianceDocumentsTypeFilter',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
